import revive_payload_client_4sVQNw7RlN from "/builds/common/careers/careers-static/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import router_jmwsqit4Rs from "/builds/common/careers/careers-static/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import plugin_vue3_A0OWXRrUgq from "/builds/common/careers/careers-static/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/builds/common/careers/careers-static/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "/builds/common/careers/careers-static/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import prefetch_client_5tzzN0oIVL from "/builds/common/careers/careers-static/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_KlVwwuJRCL from "/builds/common/careers/careers-static/node_modules/@storyblok/nuxt/dist/runtime/plugin.mjs";
import composition_sLxaNGmlSL from "/builds/common/careers/careers-static/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/builds/common/careers/careers-static/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_eTVJQYlCmx from "/builds/common/careers/careers-static/node_modules/@nuxtjs/apollo/dist/runtime/plugin.mjs";
import plugin_8SbxDRbG6Y from "/builds/common/careers/careers-static/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/builds/common/careers/careers-static/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import sentry_client_shVUlIjFLk from "/builds/common/careers/careers-static/plugins/sentry.client.ts";
import vue_dompurify_html_dkB45ZSnPU from "/builds/common/careers/careers-static/plugins/vue-dompurify-html.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  router_jmwsqit4Rs,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  prefetch_client_5tzzN0oIVL,
  plugin_KlVwwuJRCL,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  plugin_eTVJQYlCmx,
  plugin_8SbxDRbG6Y,
  chunk_reload_client_UciE0i6zes,
  sentry_client_shVUlIjFLk,
  vue_dompurify_html_dkB45ZSnPU
]